import gql from 'graphql-tag';

// Security #1: revoke the caller's bearer token server-side on logout.
export default () => gql`
  mutation {
    logout
  }
`;
